module.exports = __webpack_public_path__ + "static/img/Image 18.271884b8.png";